import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { DEFAULT_VIDEO_SRC } from '../../constants';
import { AppContext } from '../CategoryContext';
import ExplanationVideo from '../../../../shared/components/explanationVideo';
import './index.scss';

const Header = ({ category }) => (
    <AppContext.Consumer>
        {({ isTouch }) => (
            <div className={classNames('header', { 'mobile': isTouch })} style={{ backgroundImage: isTouch ? `url(${category.backgroundImage})` : '' }}>
                {isTouch && <img src={category.backgroundImage} alt="item-background"/>}
                <div className="header-wrapper">
                    <h1 className="title">{category.title}</h1>
                    <p className="subtitle">{category.subtitle}</p>
                    <ExplanationVideo hasVideoLink={false} subcategoryName={'test'}
                        subcat=""
                        categoryPage
                        context={AppContext}
                        src={DEFAULT_VIDEO_SRC}/>
                </div>
            </div>
        )}
    </AppContext.Consumer>
);

Header.propTypes = {
    category: PropTypes.object
};

export default Header;